module.exports = __webpack_public_path__ + "img/fig22.f49f0579.jpg";